/**
 * Detail context.
 */
import Event from '@shared/classes/event';
import Plan from '@shared/classes/plan';
import Rail from '@shared/classes/rail';
import useMetadata from '@shared/components/utils/hooks/useMetadata';
import { createContext, MutableRefObject } from 'react';

/**
 * Detail context props.
 */
export interface DetailContextProps {
  asset: Event | null;
  complete: boolean;
  focusable: MutableRefObject<{
    buttons: boolean;
    synopsis: boolean;
    related: boolean;
  }>;
  metadata: ReturnType<typeof useMetadata> | null;
  related?: Rail | null;
  upgradablePlan: Plan | null;
}

/**
 * Detail context creation.
 */
const DetailContext = createContext<DetailContextProps>({
  asset: null,
  complete: false,
  focusable: { current: { buttons: false, synopsis: false, related: false } },
  metadata: null,
  related: null,
  upgradablePlan: null,
});

export default DetailContext;
